import React, { useContext, useState } from 'react';

import { noop } from 'lodash';
import { Meta } from 'react-meta-elements';
import { useLocation, useNavigate } from 'react-router-dom';

import { IBaseProps } from '@rbi-ctg/frontend';
import { getCountry } from 'utils/environment';
import { IPlaceData } from 'utils/geolocation';

import { useDisallowedUrls } from './hooks/use-disallowed-urls';
import { useNavigateBack } from './hooks/use-navigate-back';
import { ILocation } from './types';

export { Link, useMatch } from 'react-router-dom';

export const LocationContext = React.createContext<ILocation>({} as ILocation);
export const useLocationContext = () => useContext(LocationContext);

export function LocationProvider(props: IBaseProps) {
  const [storeLocatorCallbackUrl, setStoreLocatorCallbackUrl] = useState('');

  const { addNavigateBackListener, back } = useNavigateBack();
  const addHardwareBackButtonListener = noop;
  const removeHardwareBackButtonListener = noop;
  const [referrerLocation, setReferrerLocation] = useState<string | undefined>();
  const [signUpUsername, setSignUpUsername] = useState('');
  const [deliveryAddressMapFallback, setDeliveryAddressMapFallback] = useState<IPlaceData>({
    coordinates: {
      lat: 0,
      lng: 0,
    },
    address: {
      addressLine1: '',
      city: '',
      country: getCountry(),
    },
  });
  const [eventPageName, setEventPageName] = useState<string | undefined>();

  const location = useLocation();
  const navigate = useNavigate();
  const disallowedUrls = useDisallowedUrls();

  return (
    <LocationContext.Provider
      value={{
        addNavigateBackListener,
        addHardwareBackButtonListener,
        back,
        signUpUsername,
        location,
        navigate,
        referrerLocation,
        removeHardwareBackButtonListener,
        setSignUpUsername,
        setReferrerLocation,
        setStoreLocatorCallbackUrl,
        storeLocatorCallbackUrl,
        deliveryAddressMapFallback,
        setDeliveryAddressMapFallback,
        eventPageName,
        setEventPageName,
      }}
    >
      {disallowedUrls.includes(location.pathname) && <Meta name="robots" content="none" />}
      {props.children}
    </LocationContext.Provider>
  );
}

export default LocationContext.Consumer;
